import { formatearCOP } from './expenses';

/**
 * FE-32 — Lo que los gráficos de Finanzas comparten con la página y no es un
 * componente (va aparte para que Fast Refresh funcione).
 *
 * Las tres series tienen identidad FIJA en toda la app (tiles, tabla,
 * gráficos): ingresos verde, gastos del vehículo ámbar, gastos de operación
 * violeta. Los valores de los tokens `--fin-*` viven en index.css, con un paso
 * distinto por tema (validados para daltonismo en los dos fondos).
 */
export const SERIE = {
  income: 'var(--fin-income)',
  vehicle: 'var(--fin-vehicle)',
  operation: 'var(--fin-ops)',
  result: 'var(--text-primary)',
  negative: 'var(--critical)',
} as const;

const decimal = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 1 });
/** Para ejes y etiquetas dentro de la gráfica: `$ 4,4 M`, `$ 470 mil`. */
export function pesosCortos(v: number): string {
  const s = v < 0 ? '−' : '';
  const a = Math.abs(v);
  if (a >= 1_000_000) return `${s}$ ${decimal.format(a / 1_000_000)} M`;
  if (a >= 1_000) return `${s}$ ${decimal.format(a / 1_000)} mil`;
  return `${s}$ ${decimal.format(a)}`;
}
export const pesos = (v: number) => (v < 0 ? `−${formatearCOP(String(-v))}` : formatearCOP(String(v)));

export interface Porcion { key: string; label: string; value: number; color: string }

/** Paleta categórica de referencia (validada): para clientes y otros ejes sin color propio. */
export const PALETA_CATEGORICA = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#6250d6', '#008300', '#e34948'];

/** Máximo 6 porciones con nombre; el resto se pliega en «Otros». */
export function plegar(items: { key: string; label: string; value: number; color?: string }[], max = 6): Porcion[] {
  const orden = [...items].filter(i => i.value > 0).sort((a, b) => b.value - a.value);
  const cabeza = orden.slice(0, max).map((i, idx) => ({ ...i, color: i.color ?? PALETA_CATEGORICA[idx % PALETA_CATEGORICA.length] }));
  const cola = orden.slice(max);
  if (cola.length > 0) cabeza.push({ key: '__otros', label: `Otros (${cola.length})`, value: cola.reduce((s, i) => s + i.value, 0), color: 'var(--text-muted)' });
  return cabeza;
}
